export const REPORT_OUTPUT_MODES = {
  PRINT_STYLE: 'print-style',
  PDF_STICKER: 'pdf-sticker',
  PDF_OVERLAY: 'pdf-overlay',
}

export const REPORT_OUTPUT_MODE_OPTIONS = [
  { label: 'Print Web Style', value: REPORT_OUTPUT_MODES.PRINT_STYLE },
  {
    label: 'PDF Sticker',
    value: REPORT_OUTPUT_MODES.PDF_STICKER,
  },
  {
    label: 'PDF Overlay (POC)',
    value: REPORT_OUTPUT_MODES.PDF_OVERLAY,
  },
]

const OUTPUT_MODE_VALUES = Object.values(REPORT_OUTPUT_MODES)

export const getReportOutputMode = (publishData = {}) => {
  if (OUTPUT_MODE_VALUES.includes(publishData.outputMode)) {
    return publishData.outputMode
  }

  if (publishData.pdfStickerStyle === true) {
    return REPORT_OUTPUT_MODES.PDF_STICKER
  }

  if (publishData.printStyle === true || publishData.exportExcel === true) {
    return REPORT_OUTPUT_MODES.PRINT_STYLE
  }

  return ''
}

export const applyReportOutputMode = (publishData = {}, outputMode = '') => {
  const normalizedMode = OUTPUT_MODE_VALUES.includes(outputMode)
    ? outputMode
    : ''

  return {
    ...publishData,
    outputMode: normalizedMode,
    printStyle: normalizedMode === REPORT_OUTPUT_MODES.PRINT_STYLE,
    pdfStickerStyle: normalizedMode === REPORT_OUTPUT_MODES.PDF_STICKER,
    exportExcel:
      normalizedMode === REPORT_OUTPUT_MODES.PRINT_STYLE
        ? publishData.exportExcel === true
        : false,
  }
}

export const isPdfOverlayOutputMode = (publishData = {}) =>
  getReportOutputMode(publishData) === REPORT_OUTPUT_MODES.PDF_OVERLAY

export const isPrintStyleOutputMode = (publishData = {}) =>
  getReportOutputMode(publishData) === REPORT_OUTPUT_MODES.PRINT_STYLE
